module.exports = __webpack_public_path__ + "assets/system.5ba6d8fb.svg";